import Id from './Id';
import Status from './Status';
import Supplier from './Supplier';
import DeliveryDate from './DeliveryDate';
import CreatorUser from './CreatorUser';
import Storage from './Storage';
import ReceiptNumber from './ReceiptNumber';
import NetPrice from './NetPrice';
import GrossPrice from './GrossPrice';
import Created from './Created';
import Updated from './Updated';

export const compareTypes = {
  net_price: 'number',
  gross_price: 'number',
};

export const labels = {
  Id: 'Id',
  ReceiptNumber: 'Bizonylatszám',
  Status: 'Státusz',
  Supplier: 'Beszállító',
  Storage: 'Raktár',
  DeliveryDate: 'Szállítás dátuma',
  CreatorUser: 'Rögzítette',
  NetPrice: 'Nettó ár',
  GrossPrice: 'Bruttó ár',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Supplier',
}, {
  value: 'Storage',
}, {
  value: 'DeliveryDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'GrossPrice',
}, {
  value: 'Updated',
}, {
  value: 'Created',
}, {
  value: 'Status',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'ReceiptNumber',
}, {
  value: 'Status',
}, {
  value: 'Supplier',
}, {
  value: 'Storage',
}, {
  value: 'DeliveryDate',
}, {
  value: 'CreatorUser',
}, {
  value: 'NetPrice',
}, {
  value: 'Created',
}];

export const defaultSort = {
  prop: Created.propName,
  order: 'ascending'
};

export default {
  Id,
  ReceiptNumber,
  Status,
  Supplier,
  Storage,
  DeliveryDate,
  CreatorUser,
  NetPrice,
  GrossPrice,
  Created,
  Updated,
};
